<!-- Esqueleto con la geometría final: cabecera, dos bloques y la tabla. -->
<ng-container *ngIf="loading">
  <div class="sd-head" aria-busy="true" aria-label="Cargando la sesión">
    <div class="sd-title">
      <p-skeleton height="1.2rem" width="16rem"></p-skeleton>
      <p-skeleton height="1.3rem" width="4.5rem" borderRadius="6px"></p-skeleton>
    </div>
  </div>
  <div class="sd-grid">
    <div class="sd-block"><p-skeleton height="6rem" width="100%" borderRadius="12px"></p-skeleton></div>
    <div class="sd-block"><p-skeleton height="6rem" width="100%" borderRadius="12px"></p-skeleton></div>
  </div>
  <div class="pt-wrap sd-table">
    <table class="pt-table">
      <tbody>
        <tr *ngFor="let s of skeleton" aria-hidden="true">
          <td><p-skeleton width="1.2rem" height="1.2rem" borderRadius="4px"></p-skeleton></td>
          <td><p-skeleton height="0.8rem" width="5rem"></p-skeleton></td>
          <td><p-skeleton height="0.8rem" width="10rem"></p-skeleton></td>
          <td><p-skeleton height="0.8rem" width="8rem"></p-skeleton></td>
          <td><p-skeleton height="0.8rem" width="6rem"></p-skeleton></td>
          <td><p-skeleton height="1.3rem" width="5rem" borderRadius="6px"></p-skeleton></td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>

<!-- Error: se dice y se ofrece volver; una sesión que no carga no es una pantalla en blanco. -->
<div class="cb-empty" *ngIf="!loading && error">
  <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
  <p class="cb-empty-t">No se pudo cargar la sesión</p>
  <p class="cb-empty-b">{{ error }}</p>
  <div class="sd-empty-actions">
    <button
      pButton
      type="button"
      label="Reintentar"
      icon="fa-solid fa-rotate-right"
      class="p-button-sm p-button-outlined"
      (click)="reload()"
    ></button>
    <button
      pButton
      type="button"
      label="Volver a sesiones"
      icon="fa-solid fa-chevron-left"
      class="p-button-sm p-button-text"
      (click)="goBack()"
    ></button>
  </div>
</div>

<ng-container *ngIf="!loading && session as s">
  <!-- Cabecera DE LA VISTA, no otra tarjeta: la tarjeta ya la pone el cascarón. -->
  <div class="sd-head">
    <div class="sd-title">
      <h4>Comité del {{ s.sessionDate | date: 'dd/MM/yyyy HH:mm' }}</h4>
      <span class="pt-pill" [ngClass]="'is-' + (statusPill[s.status]?.tone || 'muted')">{{ statusPill[s.status]?.label || s.status }}</span>
      <span class="pt-pill" [class.is-info]="s.kind === 'voting'" [class.is-muted]="s.kind !== 'voting'">{{ kindLabel[s.kind] }}</span>
      <span class="sd-meta">{{ s.itemsCount }} {{ s.itemsCount === 1 ? 'arrendamiento' : 'arrendamientos' }}</span>
      <span class="sd-meta" *ngIf="s.lastNotifiedAt">· aviso enviado el {{ s.lastNotifiedAt | date: 'dd/MM/yyyy HH:mm' }}</span>
    </div>

    <div class="sd-actions">
      <button
        *ngIf="canNotify"
        pButton
        type="button"
        label="Reenviar aviso"
        icon="fa-solid fa-paper-plane"
        class="p-button-sm p-button-outlined sd-act-notify"
        [loading]="notifying"
        pTooltip="Vuelve a mandar el correo solo a quien todavía tiene votos pendientes"
        tooltipPosition="bottom"
        (click)="notify()"
      ></button>
      <button
        *ngIf="canClose"
        pButton
        type="button"
        label="Cerrar sesión"
        icon="fa-solid fa-flag-checkered"
        class="p-button-sm sd-act-close"
        [disabled]="busy"
        (click)="confirmClose()"
      ></button>
    </div>
  </div>

  <p class="sd-comments" *ngIf="s.generalComments">
    <i class="fa-solid fa-align-left" aria-hidden="true"></i>
    <span>{{ s.generalComments }}</span>
  </p>
  <!-- Se cerró con dictamen manual (sin votos con quórum): el motivo va a la vista, no solo a la bitácora. -->
  <p class="sd-comments sd-manual-reason" *ngIf="s.closedReason">
    <i class="fa-solid fa-user-pen" aria-hidden="true"></i>
    <span><b>Dictamen manual:</b> {{ s.closedReason }}</span>
  </p>

  <div class="sd-grid">
    <!-- Votantes: solo en una votación. Una sesión de registro no convoca a nadie (D-2). -->
    <section class="sd-block" *ngIf="isVoting">
      <header class="sd-block-head">
        <h5><i class="fa-solid fa-people-group" aria-hidden="true"></i> Votantes</h5>
        <span class="sd-count"
          ><b>{{ votersDone }}</b
          >/{{ s.voters.length }} {{ s.votesCast > 0 ? 'votaron todo' : 'sin votos en la plataforma' }}</span
        >
        <button
          *ngIf="canEditVoters"
          pButton
          type="button"
          label="Editar"
          icon="fa-solid fa-user-pen"
          class="p-button-text p-button-sm sd-act-voters"
          [disabled]="busy"
          (click)="openVoters()"
        ></button>
      </header>
      <ul class="sd-voters">
        <li *ngFor="let v of s.voters">
          <span class="cm-avatar" aria-hidden="true">{{ initialsOf(v.user) }}</span>
          <div class="sd-voter-text">
            <span class="sd-voter-name">{{ nameOf(v.user) }}<span class="sd-you" *ngIf="isMe(v.user)"> (tú)</span></span>
            <span class="sd-voter-mail">{{ v.user.email }}</span>
          </div>
          <span class="pt-pill pt-num" [class.is-ok]="!v.pendingCount" [class.is-warn]="v.pendingCount">
            {{ v.pendingCount ? 'Pendiente · ' + v.votedCount + '/' + s.itemsCount : v.votedCount + '/' + s.itemsCount + ' votados' }}
          </span>
        </li>
        <li class="sd-empty" *ngIf="!s.voters.length">Esta sesión no tiene votantes convocados.</li>
      </ul>
    </section>

    <!-- Actas: se suben UNA vez y quedan ligadas a todos los arrendamientos (D-5). Sin candado de
         estado: Legal las redacta por fuera y llegan cuando el comité ya decidió. -->
    <section class="sd-block" [class.sd-block--wide]="!isVoting">
      <header class="sd-block-head">
        <h5><i class="fa-regular fa-file-lines" aria-hidden="true"></i> Actas</h5>
        <span class="sd-count" *ngIf="s.minutes.length"
          ><b>{{ s.minutes.length }}</b></span
        >
      </header>

      <ul class="sd-minutes" *ngIf="s.minutes.length; else sinActas">
        <li *ngFor="let m of s.minutes">
          <i class="fa-regular fa-file-pdf sd-minute-icon" aria-hidden="true"></i>
          <div class="sd-minute-text">
            <span class="sd-minute-name">{{ m.name }}</span>
            <span class="sd-minute-meta" *ngIf="m.uploadedAt">{{ m.uploadedAt | date: 'dd/MM/yyyy HH:mm' }}</span>
          </div>
          <button
            pButton
            type="button"
            icon="fa-solid fa-eye"
            class="p-button-text p-button-sm sd-act-preview"
            pTooltip="Previsualizar"
            tooltipPosition="top"
            [attr.aria-label]="'Previsualizar ' + m.name"
            (click)="previewMinute(m)"
          ></button>
          <button
            pButton
            type="button"
            icon="fa-solid fa-download"
            class="p-button-text p-button-sm sd-act-download"
            pTooltip="Descargar"
            tooltipPosition="top"
            [attr.aria-label]="'Descargar ' + m.name"
            (click)="downloadMinute(m)"
          ></button>
          <button
            *ngIf="canUpload"
            pButton
            type="button"
            icon="fa-solid fa-trash"
            class="p-button-text p-button-sm p-button-danger sd-act-remove"
            pTooltip="Quitar"
            tooltipPosition="top"
            [attr.aria-label]="'Quitar ' + m.name"
            [disabled]="busy"
            (click)="confirmRemoveMinute(m)"
          ></button>
        </li>
      </ul>
      <ng-template #sinActas>
        <p class="sd-empty">
          Aún no hay acta.
          <ng-container *ngIf="canUpload">
            Súbela cuando la tengas firmada: queda ligada a todos los arrendamientos de la sesión.</ng-container
          >
        </p>
      </ng-template>

      <div class="sd-upload" *ngIf="canUpload">
        <!-- Se destruye y recrea al registrar: es la única forma de dejar el selector limpio para la
             siguiente, porque `app-input-single-file` solo resetea cuando cambia `fileUrlValue`. -->
        <app-input-single-file
          *ngIf="!uploading; else subiendo"
          label="Agregar acta"
          [folder]="'committee'"
          [documentName]="'acta-comite'"
          [id]="s._id"
          [fileUrlValue]="null"
          [disabled]="busy"
          [tooltip]="'Archivo PDF con el acta de la sesión'"
          (fileUrl)="onMinuteSelected($event)"
        ></app-input-single-file>
        <ng-template #subiendo>
          <p class="sd-empty"><i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i> Registrando el acta…</p>
        </ng-template>
      </div>
    </section>
  </div>

  <!-- La tabla: un arrendamiento por fila, el voto en la fila, el resumen para decidir al desplegar. -->
  <div class="pt-wrap sd-table">
    <table class="pt-table">
      <thead>
        <tr>
          <th class="pt-col-exp"></th>
          <th>Folio</th>
          <th>Cliente</th>
          <th>Activo</th>
          <th>Votos</th>
          <th *ngIf="showMyVote">Mi voto</th>
          <th>Observaciones</th>
          <th>Resultado</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let it of s.items">
          <!-- `meeting` puede venir `null` (dato huérfano): la fila se pinta sin voto ni resultado. -->
          <ng-container *ngIf="it.meeting as m; else huerfana">
            <tr class="pt-row" [class.is-open]="isOpenRow(it)">
              <td class="pt-col-exp">
                <button
                  type="button"
                  class="pt-exp"
                  [class.is-open]="isOpenRow(it)"
                  (click)="toggle(it)"
                  [attr.aria-expanded]="isOpenRow(it)"
                  [attr.aria-label]="'Resumen de ' + (it.lease.folio || 'arrendamiento')"
                >
                  <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
                </button>
              </td>
              <td class="pt-folio">
                <a class="link-subsection" [routerLink]="['/lease', it.lease._id]" [queryParams]="{ tab: 'comite' }">{{
                  it.lease.folio || '—'
                }}</a>
              </td>
              <td>{{ it.lease.clientName || '—' }}</td>
              <td class="sd-asset">{{ it.lease.assetName || '—' }}</td>
              <td>
                <!-- ✓ ✗ ⏱ con el nombre de quién en el tooltip: forma además de color. -->
                <span class="sd-votes">
                  <span class="sd-vote-ok" [pTooltip]="whoVoted(m, 'Aprobado') || 'Nadie ha aprobado'" tooltipPosition="top">
                    <i class="fa-solid fa-check" aria-hidden="true"></i>{{ m.votes.approved }}
                  </span>
                  <span class="sd-vote-bad" [pTooltip]="whoVoted(m, 'Rechazado') || 'Nadie ha rechazado'" tooltipPosition="top">
                    <i class="fa-solid fa-xmark" aria-hidden="true"></i>{{ m.votes.rejected }}
                  </span>
                  <span
                    class="sd-vote-pend"
                    *ngIf="isVoting"
                    [pTooltip]="whoPending(m) ? 'Faltan: ' + whoPending(m) : 'Ya votaron todos'"
                    tooltipPosition="top"
                  >
                    <i class="fa-regular fa-clock" aria-hidden="true"></i>{{ m.votes.pending }}
                  </span>
                </span>
              </td>
              <td *ngIf="showMyVote" class="sd-myvote">
                <ng-container *ngIf="myVoteOn(it) as mine; else sinVoto">
                  <span class="pt-pill" [class.is-ok]="mine.decision === 'Aprobado'" [class.is-bad]="mine.decision === 'Rechazado'">{{
                    mine.decision
                  }}</span>
                </ng-container>
                <ng-template #sinVoto>
                  <ng-container *ngIf="canVoteOn(it); else noAplica">
                    <button
                      type="button"
                      class="cm-choice approve"
                      [attr.aria-label]="'Aprobar ' + (it.lease.folio || '')"
                      [disabled]="busy"
                      (click)="openVote(it, 'Aprobado')"
                    >
                      <i class="fa-solid fa-check" aria-hidden="true"></i> Aprobar
                    </button>
                    <button
                      type="button"
                      class="cm-choice reject"
                      [attr.aria-label]="'Rechazar ' + (it.lease.folio || '')"
                      [disabled]="busy"
                      (click)="openVote(it, 'Rechazado')"
                    >
                      <i class="fa-solid fa-xmark" aria-hidden="true"></i> Rechazar
                    </button>
                  </ng-container>
                  <ng-template #noAplica><span class="pt-dash">—</span></ng-template>
                </ng-template>
              </td>
              <td class="sd-obs">
                <ng-container *ngIf="editingMeetingId === m._id; else obsTexto">
                  <textarea
                    pInputTextarea
                    rows="2"
                    [(ngModel)]="editingText"
                    class="sd-obs-input"
                    [attr.aria-label]="'Observación sobre ' + (it.lease.folio || 'el arrendamiento')"
                    [disabled]="busy"
                  ></textarea>
                  <div class="sd-obs-actions">
                    <button
                      pButton
                      type="button"
                      label="Guardar"
                      icon="fa-solid fa-check"
                      class="p-button-sm"
                      [disabled]="busy"
                      (click)="saveEdit(it)"
                    ></button>
                    <button
                      pButton
                      type="button"
                      label="Cancelar"
                      class="p-button-sm p-button-text"
                      [disabled]="busy"
                      (click)="cancelEdit()"
                    ></button>
                  </div>
                </ng-container>
                <ng-template #obsTexto>
                  <span class="sd-obs-text" [class.pt-dash]="!m.generalComments">{{ m.generalComments || '—' }}</span>
                  <button
                    *ngIf="canEditItem(it)"
                    pButton
                    type="button"
                    icon="fa-solid fa-pen"
                    class="p-button-text p-button-sm sd-obs-edit"
                    pTooltip="Anotar sobre este arrendamiento"
                    tooltipPosition="top"
                    [attr.aria-label]="'Editar la observación de ' + (it.lease.folio || 'el arrendamiento')"
                    (click)="startEdit(it)"
                  ></button>
                </ng-template>
              </td>
              <td>
                <!-- Cerrada: el resultado. Abierta: la proyección con «~», para que no se lea como decidido. -->
                <ng-container *ngIf="m.meetingStatus !== 'Open'; else proyeccion">
                  <span class="pt-pill" [ngClass]="'is-' + (meetingPill[m.meetingStatus]?.tone || 'muted')">{{
                    resultLabel(m.meetingStatus)
                  }}</span>
                  <i
                    *ngIf="m.decisionSource === 'manual'"
                    class="fa-solid fa-user-pen sd-manual"
                    role="img"
                    [pTooltip]="'Dictamen manual: ' + (m.closedReason || '')"
                    tooltipPosition="top"
                    [attr.aria-label]="'Dictamen manual: ' + (m.closedReason || '')"
                  ></i>
                </ng-container>
                <ng-template #proyeccion>
                  <span
                    class="pt-pill is-muted sd-projected"
                    pTooltip="Proyección con los votos de ahora; se decide al cerrar"
                    tooltipPosition="top"
                  >
                    ~ {{ resultLabel(m.projected) }}
                  </span>
                  <i
                    class="fa-solid fa-triangle-exclamation sd-quorum-warn"
                    *ngIf="isVoting && !m.quorumOk"
                    pTooltip="Sin quórum: con menos de la mitad de los votos esta fila frena el cierre"
                    tooltipPosition="top"
                  ></i>
                </ng-template>
              </td>
            </tr>

            <!-- El resumen para decidir, DEBAJO de su fila. Ya vino con la sesión: nada que pedir. -->
            <tr class="pt-detalle" *ngIf="isOpenRow(it)">
              <td [attr.colspan]="columns">
                <div class="pt-det">
                  <section>
                    <h4>Resumen para decidir</h4>
                    <dl class="sd-brief">
                      <div>
                        <dt>Valor del activo</dt>
                        <dd>
                          {{ it.brief.assetValue !== null ? (it.brief.assetValue | currency: 'MXN' : 'symbol-narrow' : '1.2-2') : '—' }}
                        </dd>
                      </div>
                      <div>
                        <dt>Plazo</dt>
                        <dd>{{ it.brief.term || '—' }}</dd>
                      </div>
                      <div>
                        <dt>Renta</dt>
                        <dd>{{ it.brief.rent !== null ? (it.brief.rent | currency: 'MXN' : 'symbol-narrow' : '1.2-2') : '—' }}</dd>
                      </div>
                      <div>
                        <dt>Dictamen legal</dt>
                        <dd>
                          <ng-container *ngIf="it.brief.legal as legal; else sinDato">
                            <b *ngIf="legal.score !== null">{{ legal.score }}/100</b>
                            <button
                              *ngIf="legal.file"
                              type="button"
                              class="pt-link"
                              (click)="previewFile(legal.file, 'Dictamen legal ' + (it.lease.folio || ''))"
                            >
                              Ver dictamen
                            </button>
                            <span *ngIf="legal.score === null && !legal.file">—</span>
                          </ng-container>
                        </dd>
                      </div>
                      <div>
                        <dt>Riesgo</dt>
                        <dd>
                          <ng-container *ngIf="it.brief.risk as risk; else sinDato">
                            <b *ngIf="risk.score !== null">{{ risk.score | number: '1.0-2' }}</b>
                            <span *ngIf="risk.decision"> · {{ risk.decision }}</span>
                            <small class="sd-brief-src" *ngIf="risk.score !== null || risk.decision">{{
                              riskSourceLabel[risk.source] || risk.source
                            }}</small>
                            <span *ngIf="risk.score === null && !risk.decision">—</span>
                          </ng-container>
                        </dd>
                      </div>
                      <div>
                        <dt>Presentación a comité</dt>
                        <dd>
                          <ng-container *ngIf="it.brief.presentation?.length; else sinDato">
                            <button
                              *ngFor="let p of it.brief.presentation; let i = index"
                              type="button"
                              class="pt-link sd-brief-file"
                              (click)="previewFile(p.url, p.name || 'Presentación a comité ' + (it.lease.folio || ''))"
                            >
                              {{ p.name || 'Archivo ' + (i + 1) }}
                            </button>
                          </ng-container>
                        </dd>
                      </div>
                    </dl>
                    <ng-template #sinDato>—</ng-template>
                  </section>

                  <section>
                    <h4>Comentarios de los votantes</h4>
                    <p class="pt-det-vacio" *ngIf="!voterComments(m).length">Nadie ha dejado comentario en este arrendamiento.</p>
                    <ul class="sd-comments-list" *ngIf="voterComments(m).length">
                      <li *ngFor="let c of voterComments(m)">
                        <span class="pt-pill" [class.is-ok]="c.decision === 'Aprobado'" [class.is-bad]="c.decision === 'Rechazado'">{{
                          c.decision
                        }}</span>
                        <b>{{ c.name }}</b>
                        <p>{{ c.text }}</p>
                      </li>
                    </ul>
                  </section>
                </div>
              </td>
            </tr>
          </ng-container>

          <ng-template #huerfana>
            <tr class="pt-row">
              <td class="pt-col-exp"></td>
              <td class="pt-folio">
                <a class="link-subsection" [routerLink]="['/lease', it.lease._id]" [queryParams]="{ tab: 'comite' }">{{
                  it.lease.folio || '—'
                }}</a>
              </td>
              <td>{{ it.lease.clientName || '—' }}</td>
              <td class="sd-asset">{{ it.lease.assetName || '—' }}</td>
              <td [attr.colspan]="columns - 4" class="sd-orphan">La reunión de este arrendamiento ya no está en su comité.</td>
            </tr>
          </ng-template>
        </ng-container>

        <tr *ngIf="!s.items.length">
          <td [attr.colspan]="columns" class="pt-vacio">Esta sesión no tiene arrendamientos.</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>

<!-- El voto: corto, con nota opcional. `appendTo="body"` porque la tarjeta del cascarón tiene `overflow: hidden`. -->
<p-dialog
  [(visible)]="voteVisible"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!busy"
  appendTo="body"
  styleClass="sd-vote-dialog"
  [style]="{ width: '440px' }"
  [header]="voteDraft ? (voteDraft.decision === 'Aprobado' ? 'Aprobar ' : 'Rechazar ') + (voteDraft.item.lease.folio || '') : 'Mi voto'"
>
  <ng-container *ngIf="voteDraft as d">
    <p class="sd-vote-lead">
      <span class="pt-pill" [class.is-ok]="d.decision === 'Aprobado'" [class.is-bad]="d.decision === 'Rechazado'">{{ d.decision }}</span>
      <span>{{ d.item.lease.clientName || '—' }} · {{ d.item.lease.assetName || '—' }}</span>
    </p>
    <div class="field field-flex">
      <label for="voteComment">Comentario (opcional):</label>
      <textarea pInputTextarea id="voteComment" rows="3" [(ngModel)]="d.memberComments" [disabled]="busy"></textarea>
    </div>
  </ng-container>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cancelar"
      class="p-button-text p-button-sm"
      [disabled]="busy"
      (click)="voteVisible = false"
    ></button>
    <button
      pButton
      type="button"
      [label]="voteDraft?.decision === 'Rechazado' ? 'Rechazar' : 'Aprobar'"
      [icon]="voteDraft?.decision === 'Rechazado' ? 'fa-solid fa-xmark' : 'fa-solid fa-check'"
      [class]="'p-button-sm ' + (voteDraft?.decision === 'Rechazado' ? 'p-button-danger' : 'p-button-success')"
      [disabled]="busy"
      (click)="submitVote()"
    ></button>
  </ng-template>
</p-dialog>

<!-- Los votantes de la sesión, abanicados a todas sus reuniones. -->
<p-dialog
  [(visible)]="votersVisible"
  header="Editar votantes"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!busy"
  [closeOnEscape]="false"
  appendTo="body"
  styleClass="sd-voters-dialog"
  [style]="{ width: '480px' }"
>
  <!-- Escape lo decide el componente (QA-11): con el desplegable abierto solo se cierra el desplegable. -->
  <div class="field field-flex" (keydown.escape)="onVotersEscape($event)">
    <label for="sessionVoters">*Miembros votantes:</label>
    <p-multiSelect
      inputId="sessionVoters"
      [(ngModel)]="votersDraft"
      [options]="memberOptions"
      optionLabel="label"
      optionValue="value"
      placeholder="Selecciona los miembros"
      selectedItemsLabel="{0} votantes"
      [maxSelectedLabels]="2"
      [filter]="true"
      appendTo="body"
      styleClass="w-full"
      emptyMessage="No hay miembros del comité elegibles"
      emptyFilterMessage="Ningún miembro coincide"
    ></p-multiSelect>
    <small class="sd-hint">No se puede quitar a quien ya emitió algún voto en esta sesión.</small>
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cancelar"
      class="p-button-text p-button-sm"
      [disabled]="busy"
      (click)="votersVisible = false"
    ></button>
    <button
      pButton
      type="button"
      label="Guardar"
      icon="fa-solid fa-check"
      class="p-button-sm"
      [disabled]="busy || !votersDraft.length"
      (click)="saveVoters()"
    ></button>
  </ng-template>
</p-dialog>

<!-- Cerrar la sesión: por arrendamiento, con qué se cierra. Donde no hay votos con quórum, Legal dictamina y da el motivo. -->
<p-dialog
  [(visible)]="closeVisible"
  header="Cerrar la sesión"
  [modal]="true"
  [dismissableMask]="false"
  [draggable]="false"
  [resizable]="false"
  [closable]="!busy"
  [closeOnEscape]="false"
  appendTo="body"
  styleClass="sd-close-dialog"
  [style]="{ width: '640px' }"
>
  <div class="sd-close" (keydown.escape)="onCloseEscape($event)">
    <p class="sd-close-lead">Se cerrará la sesión y cada comité quedará con su resultado:</p>
    <table class="pt-table sd-close-table">
      <thead>
        <tr>
          <th>Folio</th>
          <th class="ta-c">Votos</th>
          <th>Quórum</th>
          <th>Resultado</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of closeRows">
          <td>
            <b>{{ r.folio }}</b>
          </td>
          <td class="ta-c pt-num">{{ r.cast }}/{{ r.total }}</td>
          <td>
            <!-- Con cero votos el quórum «se cumple» solo porque nadie votó: decirlo así confunde; se dice «sin votos». -->
            <ng-container *ngIf="r.cast === 0; else conVotos"><span class="sd-close-warn">sin votos</span></ng-container>
            <ng-template #conVotos>
              <span *ngIf="r.quorumOk; else sinQuorum">quórum ✓</span>
              <ng-template #sinQuorum><span class="sd-close-warn">sin quórum ✗</span></ng-template>
            </ng-template>
          </td>
          <td>
            <ng-container *ngIf="r.closedResult; else abierta">ya cerrada: {{ resultLabel(r.closedResult) }}</ng-container>
            <ng-template #abierta>
              <ng-container *ngIf="r.manual; else porVotos">
                <p-dropdown
                  [options]="decisionOptions"
                  [(ngModel)]="r.decision"
                  optionLabel="label"
                  optionValue="value"
                  appendTo="body"
                  styleClass="sd-decision"
                  [disabled]="busy"
                  [ariaLabel]="'Dictamen para ' + r.folio"
                ></p-dropdown>
              </ng-container>
              <ng-template #porVotos>→ {{ resultLabel(r.projected) }}</ng-template>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="field field-flex" *ngIf="closeNeedsReason">
      <label for="closeReason">*Motivo del dictamen:</label>
      <textarea
        pInputTextarea
        id="closeReason"
        rows="3"
        [(ngModel)]="closeReason"
        [disabled]="busy"
        placeholder="P. ej. «votada en la sesión presencial del 12 de marzo; acta adjunta»"
      ></textarea>
      <small class="sd-hint"
        >Estas reuniones no tienen votos con quórum en la plataforma: el dictamen que elijas y este motivo quedan en la reunión y en la
        bitácora de cada arrendamiento.</small
      >
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cancelar"
      class="p-button-text p-button-sm"
      [disabled]="busy"
      (click)="closeVisible = false"
    ></button>
    <button
      pButton
      type="button"
      label="Cerrar sesión"
      icon="fa-solid fa-flag-checkered"
      class="p-button-sm"
      [disabled]="!canSubmitClose"
      [loading]="busy"
      (click)="submitClose()"
    ></button>
  </ng-template>
</p-dialog>
<p-confirmDialog key="acta" appendTo="body" styleClass="sd-confirm" [style]="{ width: '440px' }"></p-confirmDialog>

<!-- El visor compartido: las actas y los archivos del resumen (dictamen, presentación). -->
<app-file-preview-dialog
  [(visible)]="previewVisible"
  [fileUrl]="previewUrl"
  [fileName]="previewName"
  (downloadRequested)="downloadPreview()"
></app-file-preview-dialog>
